import axios from 'axios';

export const postDataRequest = async function (url, variables) {
  try {    
    const response = await axios({
      url,
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        // 'Apollo-Require-Preflight': 'true',
      },
      data: {...variables.variables},
    });
    return response?.data;
  } catch (error) {
    throw error;
  }
};